var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#138e16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f7f12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#26a7dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b94c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbcd3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce2f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f03633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d82a28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "82.841605%",
    x2: "20.425965%",
    y1: "18.136653%",
    y2: "78.478772%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aa854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#219447"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0d0d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7181d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c60e13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbcd3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fecb2f"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.333333v3.809524h-5.333333z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.333333v3.809524h-5.333333z",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 7.619048h16v3.809524h-16z",
    fill: "url(#c)",
    mask: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 11.4285714h5.33333333 10.66666667v-11.4285714h-10.66666667-5.33333333z",
    fill: "url(#d)",
    mask: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.2003922 4.89804451c.7828211-.19232019 1.2757983-.24338655 1.2757983.43528882 0 1.26236515-1.705582 2.28571429-3.8095238 2.28571429-2.1039419 0-3.80952384-1.02334914-3.80952384-2.28571429 0-.67867537.49297713-.62760901 1.27579832-.43528882-.04966552-.13525384-.09121135-.27860379-.12303688-.42833134-.2187171-1.02898286.10447094-1.96952141.72186065-2.10075165.61738979-.13123024 1.29518815.59654206 1.51390525 1.62552493.1031011.48505237.0857862.95045165-.0259986 1.32068952.1466169.01163621.2957771.01815736.4469951.01815736.1512179 0 .3003781-.00652115.446995-.01815736-.1117847-.37023787-.1290996-.83563715-.0259986-1.32068952.2187171-1.02898287.8965155-1.75675517 1.5139053-1.62552493.6173897.13123024.9405777 1.07176879.7218606 2.10075165-.0318255.14972755-.0733713.2930775-.1230368.42833134z",
    fill: "url(#e)",
    mask: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.0201091 9.8645437c.1072485.0536243.2334856.0536243.3407342 0l1.5238095-.76190477c.1881822-.09409112.2644582-.32291893.1703671-.51110125-.0940911-.18818225-.3229189-.26445821-.5111013-.17036709l-1.3534424.67672122-1.3534424-.67672122c-.1072486-.0536243-.2334857-.0536243-.3407342 0l-1.35344246.67672122-1.35344244-.67672122c-.18818228-.09409112-.41701011-.01781516-.51110125.17036709-.09409114.18818232-.0178152.41701013.17036708.51110125l1.52380953.76190477c.10724853.0536243.23348564.0536243.34073417 0l1.35344247-.67672122z",
    fill: "url(#a)",
    mask: "url(#k)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.333333v3.809524h-5.333333z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.04761905 1.52380952v-3.04761904h-.76190476v3.04761904h-3.04761905v.76190477h3.04761905v3.04761904h.76190476v-3.04761904h3.04761905v-.76190477z",
    fill: "url(#g)",
    mask: "url(#l)",
    transform: "matrix(.70710678 -.70710678 .70710678 .70710678 -.565821 2.44351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.04761905 1.52380952v-2.28571428h-.76190476v2.28571428h-2.28571429v.76190477h2.28571429v2.28571428h.76190476v-2.28571428h2.28571428v-.76190477z",
    fill: "url(#a)",
    mask: "url(#m)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.809524h5.333333v3.809524h-5.333333z",
    fill: "url(#a)",
    mask: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.14285714 5.33333333c-.21039418 0-.38095238-.17055819-.38095238-.38095238 0-.21039418.1705582-.38095238.38095238-.38095238.21039419 0 .38095238.1705582.38095238.38095238 0 .21039419-.17055819.38095238-.38095238.38095238zm1.52380953 0c-.21039419 0-.38095238-.17055819-.38095238-.38095238 0-.21039418.17055819-.38095238.38095238-.38095238.21039418 0 .38095238.1705582.38095238.38095238 0 .21039419-.1705582.38095238-.38095238.38095238zm1.52380952 0c-.21039419 0-.38095238-.17055819-.38095238-.38095238 0-.21039418.17055819-.38095238.38095238-.38095238s.38095238.1705582.38095238.38095238c0 .21039419-.17055819.38095238-.38095238.38095238zm-.76190476 1.52380953c-.21039419 0-.38095238-.1705582-.38095238-.38095238 0-.21039419.17055819-.38095238.38095238-.38095238s.38095238.17055819.38095238.38095238c0 .21039418-.17055819.38095238-.38095238.38095238zm-1.52380953 0c-.21039418 0-.38095238-.1705582-.38095238-.38095238 0-.21039419.1705582-.38095238.38095238-.38095238.21039419 0 .38095239.17055819.38095239.38095238 0 .21039418-.1705582.38095238-.38095239.38095238z",
    fill: "url(#h)",
    mask: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 7.619048h5.333333v3.809524h-5.333333z",
    fill: "url(#i)",
    mask: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.66666667 9.14285714c-1.05197095 0-1.90476191-.17055817-1.90476191-.38095238s.85279096-.38095238 1.90476191-.38095238 1.9047619.17055817 1.9047619.38095238-.85279095.38095238-1.9047619.38095238zm0 1.52380956c-1.05197095 0-1.90476191-.1705582-1.90476191-.3809524s.85279096-.3809524 1.90476191-.3809524 1.9047619.1705582 1.9047619.3809524-.85279095.3809524-1.9047619.3809524z",
    fill: "url(#j)",
    mask: "url(#k)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPm);
export default __webpack_public_path__ + "static/media/PM.f1ef8c9b9acd3e0230b9ecc2de150990.svg";
export { ForwardRef as ReactComponent };